import Axios from "../BaseAxios";
import { API_CLIENT_URL, API_COMMON_URL } from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";

const ClientApiHelper = {
  getClientTeamList: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_CLIENT_URL.clientTeamList,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  getServiceProviderList: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_COMMON_URL.serviceProviderList,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },

  getServiceSteps(requestParams, successHandler, failureHandler) {
    Axios.request_POST(
      API_CLIENT_URL.clientServiceStepList,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  updateActionStatus(
    taskId,
    status,
    successHandler = null,
    failureHandler = null
  ) {
    let requestParams = {};

    requestParams[Keys.TASK_ID] = taskId;
    requestParams[Keys.STATUS] = status;

    Axios.request_PUT(
      API_CLIENT_URL.taskUpdateStatus,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
  getPublicResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.publicResources.loading = false;

      if (store.state.publicResources.pagination.page == 1)
        store.state.publicResources.items = [];

      if (store.state.publicResources.items.length < 1) {
        store.state.publicResources.items = res.data.data;
      } else {
        store.state.publicResources.items = store.state.publicResources.items.concat(
          res.data.data
        );
      }
      store.state.publicResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.publicResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] = store.state.publicResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.publicResources.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;

    if (
      store.state.publicResources.pagination.page >
      Math.ceil(store.state.publicResources.items.length / 16)
    ) {
      store.state.publicResources.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.publicResourceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle,
        false
      );
    }
  },
  getAllResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.allResources.loading = false;

      if (store.state.allResources.pagination.page == 1)
        store.state.allResources.items = [];

      if (store.state.allResources.items.length < 1) {
        store.state.allResources.items = res.data.data;
      } else {
        store.state.allResources.items = store.state.allResources.items.concat(
          res.data.data
        );
      }
      store.state.allResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.allResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] = store.state.allResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.allResources.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;
    if (
      store.state.allResources.pagination.page >
      Math.ceil(
        store.state.allResources.items.length / 16
      ) /** Math.ceil() Rounds a number upward to its nearest integer: **/
    ) {
      store.state.allResources.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.resourceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },
  getMyResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      console.log(res);
      store.state.myResources.loading = false;

      if (store.state.myResources.pagination.page == 1)
        store.state.myResources.items = [];

      if (store.state.myResources.items.length < 1) {
        store.state.myResources.items = res.data.data;
      } else {
        store.state.myResources.items = store.state.myResources.items.concat(
          res.data.data
        );
      }
      store.state.myResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.myResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] = store.state.myResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.myResources.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;

    if (
      store.state.myResources.pagination.page >
      Math.ceil(store.state.myResources.items.length / 16)
    ) {
      store.state.myResources.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.resourceMyList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },
  getBookmarkedResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.bookmarkedResources.loading = false;

      if (store.state.bookmarkedResources.pagination.page == 1)
        store.state.bookmarkedResources.items = [];

      if (store.state.bookmarkedResources.items.length < 1) {
        store.state.bookmarkedResources.items = res.data.data;
      } else {
        store.state.bookmarkedResources.items = store.state.bookmarkedResources.items.concat(
          res.data.data
        );
      }
      store.state.bookmarkedResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.bookmarkedResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] =
      store.state.bookmarkedResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.bookmarkedResources.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;

    if (
      store.state.bookmarkedResources.pagination.page >
      Math.ceil(store.state.bookmarkedResources.items.length / 16)
    ) {
      store.state.bookmarkedResources.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.resourceBookmarkList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },
  getResourcesToManage(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.managementResources.loading = false;

      if (store.state.managementResources.pagination.page == 1)
        store.state.managementResources.items = [];

      if (store.state.managementResources.items.length < 1) {
        store.state.managementResources.items = res.data.data;
      } else {
        store.state.managementResources.items = store.state.managementResources.items.concat(
          res.data.data
        );
      }
      store.state.managementResources.itemsTotal = res.data.recordsTotal;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.managementResources.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] =
      store.state.managementResources.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.managementResources.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;

    if (
      store.state.managementResources.pagination.page >
      Math.ceil(store.state.managementResources.items.length / 16)
    ) {
      store.state.managementResources.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.resourceManagementList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },
  updateResourceStatus(requestParams, successHandler, failureHandler) {
    Axios.request_POST(
      API_CLIENT_URL.resourceApprovalStatusUpdate,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  addRemoveBookmark(requestParams, successHandler, failureHandler) {
    Axios.request_POST(
      API_CLIENT_URL.resourceBookmark,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  addResourceToStudents: (
    resourceId,
    studentIdList,
    successHandler = null,
    failureHandler = null,
    assign_to = null,
    is_contact = null
  ) => {
    let requestParams = {};
    requestParams[Keys.RESOURCE_ID] = resourceId;
    requestParams[Keys.STUDENTS] = studentIdList;
    if (assign_to) requestParams[Keys.ASSIGNED_TO] = assign_to;
    if (is_contact) requestParams[Keys.IS_CONTACT] = is_contact;

    Axios.request_POST(
      API_CLIENT_URL.studentResourceAdd,
      requestParams,
      {},
      successHandler,
      failureHandler,
      true
    );
  },
  addClientMasterStep: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_POST(
      API_CLIENT_URL.clientStepAdd,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
  deleteStudentResouerce: (
    requestParams,
    successHandler = null,
    failureHandler = null
  ) => {
    Axios.request_DELETE(
      API_CLIENT_URL.studentResourceDelete,
      requestParams,
      {},
      successHandler,
      failureHandler,
      false
    );
  },
  getSessionResources(isCancle = false, dataTableParams) {
    const successHandler = (res) => {
      store.state.sessionResourceList.loading = false;

      // if (store.state.sessionResourceList.pagination.page == 1)
      //   store.state.sessionResourceList.items = [];

      // if (store.state.sessionResourceList.items.length < 1) {
      //   store.state.sessionResourceList.items = res.data.data;
      // } else {
      //   store.state.sessionResourceList.items = store.state.sessionResourceList.items.concat(
      //     res.data.data
      //   );
      // }
      // store.state.sessionResourceList.itemsTotal = res.data.recordsTotal;
      store.state.sessionResourceList.items = res.data.data;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.sessionResourceList.loading = false;
    };

    // let dataTableParams = {};
    dataTableParams[Keys.LENGTH] = 16;

    dataTableParams[Keys.PAGE] =
      store.state.sessionResourceList.pagination.page;
    dataTableParams[Keys.SEARCH] = store.state.sessionResourceList.search;

    dataTableParams[Keys.FLAG_DESCENDING] = true;
    dataTableParams[Keys.SORTING_COLUMN] = 4;
    if (
      store.state.sessionResourceList.pagination.page >
      Math.ceil(
        store.state.sessionResourceList.items.length / 16
      ) /** Math.ceil() Rounds a number upward to its nearest integer: **/
    ) {
      store.state.sessionResourceList.loading = true;
      Axios.request_POST(
        API_CLIENT_URL.sessionResourceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        isCancle
      );
    }
  },
};

export default ClientApiHelper;
